export default function mmgLinks(state = {}) {
    return state;
}
